/* ─── Group container ─── */

.group {
  display: inline-flex;
  border: 1px solid var(--md-outline);
  border-radius: var(--shape-full);
  overflow: hidden;
}

/* ─── Individual segment ─── */

.item {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: 2.5rem;
  padding-inline: var(--space-4);
  border: none;
  border-inline-end: 1px solid var(--md-outline);
  background: transparent;
  color: var(--md-on-surface);
  font-family: var(--font-sans);
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background var(--motion-duration-short3)
      var(--motion-easing-standard),
    color var(--motion-duration-short3) var(--motion-easing-standard);
}

.item:last-child {
  border-inline-end: none;
}

/* ─── State layer ─── */

.item::before {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .item:hover::before {
    opacity: var(--state-hover);
  }
}

.item:focus-visible::before {
  opacity: var(--state-focus);
}

.item:active::before {
  opacity: var(--state-pressed);
}

/* ─── Focus ring ─── */

.item:focus-visible {
  z-index: 1;
}

/* ─── Selected state ─── */

.item[data-pressed] {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
}

/* ─── Disabled ─── */

.item:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.item:disabled::before {
  display: none;
}

/* ─── Icon within segment ─── */

.icon {
  display: inline-flex;
  font-size: var(--icon-size-sm);
}
